import { Col, Row } from "antd";
import {
  DropDown,
  InputField,
  SubmitButton,
  TimePickerInput,
  DatePickerInput,
} from "../../../../components";
import styles from "./CreateCountdown.module.css";
import RoomImage from "../../../../assets/imageplace.jpg";
import { CalendarIcon, ClockIcon } from "../../../../components/icons/Icons";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { EventMiddleware } from "../../../../Store/Middlewares/EventMiddleware";
import { useDispatch } from "react-redux";
import moment from "moment";
import { showAlert } from "../../../../Store/Actions/GeneralActions";

const CreateCountdown = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {state} = useLocation()
  console.log("stateeeeeeeeee", state);
  const [BrideName, setBrideName] = useState( state?.clientDashBoardData?.bride?.name ? state?.clientDashBoardData?.bride?.name : '',);
  const [GroomName, setGroomName] = useState(state?.clientDashBoardData?.groom?.name ? state?.clientDashBoardData?.groom?.name : '',);
  const [date, setdate] = useState();
  const [Time, setTime] = useState();

  const [image, setImage] = useState(state?.clientDashBoardData?.image);
  const onCreateCountDown = () => {
    if (!GroomName || !BrideName || !date || !Time) {
      dispatch(
        showAlert({
          title: 'Create Count Down',
          message: 'All fields are mandatory.',
          type: 'Error',
          status: 400,
        }),
      );
      return;
    } else {
      let countdownData = {
        GroomName,
        BrideName,
        date: moment(date?.$d).format('YYYY-MM-DD'),
        time: moment(Time?.$d).format('HH:mm'),
        id: state?.clientDashBoardData?.id,
      };
      dispatch(EventMiddleware.createCountDown(countdownData))
        .then(() => navigate(-1))
        .catch(err => console.log(err));
    }
  };
  return (
    <>
      <Row className={styles.row} justify={"space-between"}>
        <Col className={styles.inputColumn}>
        <InputField label="Name" inputWidth="48%"
          value={BrideName}
          disabled={true}
          onChange={(e)=>setBrideName(e.target.value)}
          />
          <InputField label="To" inputWidth="48%"
          value={GroomName}
          disabled={true}

          onChange={(e) => setGroomName(e.target.value)}
          />
          <DatePickerInput
            label="Set Date"
            inputWidth="48%"
            value={date}
            onChange={(e) => setdate(e)}
            icon={<CalendarIcon size={25} />}
          />
          <TimePickerInput
            label="Set Time"
            inputWidth="48%"
            value={Time}
            onChange={(e) => setTime(e)}
            icon={<ClockIcon size={25} />}
          />
          <InputField label="Event Name" inputWidth="100%"
          value={state?.clientDashBoardData?.name}
          />
          <InputField label="Event Category" inputWidth="100%"
          value={state?.clientDashBoardData?.category?.name}
          />
        </Col>
        <Col className={styles.imgColumn}>
          <img className={styles.img} src={state?.clientDashBoardData?.image ? state?.clientDashBoardData?.image : RoomImage} />
        </Col>
      </Row>
      <SubmitButton
        title={"Create"}
        btnClass={styles.solidBtn}
        onClick={onCreateCountDown}
      />
    </>
  );
};

export default CreateCountdown;
